import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import ContactHeaderHero from '../components/Contact/ContactHeaderHero'
import Contact from '../components/Contact/Contact'
import Footer from '../components/Footer/Footer'

const Contactpage = () => {
    return (
        <div>
        <Navbar/>
        <ContactHeaderHero/>
        <Contact/>
        <Footer/>

        </div>
    )
}

export default Contactpage